module.exports = __webpack_public_path__ + "img/berger.fda22f30.jpg";